import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05cd22c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flake-breadcrumb blog-breadcrumb" }
const _hoisted_2 = { class: "clouds" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container breadcrumb-container" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "breadcrumb_title" }, "ProxyScrape blog")
], -1))

import { reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const img = reactive({
  cloud1: require('@/blog/assets/img/cloud1.png'),
  cloud2: require('@/blog/assets/img/cloud2.png'),
  cloud3: require('@/blog/assets/img/cloud3.png'),
  cloud5: require('@/blog/assets/img/cloud5.png'),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        width: "123",
        height: "63",
        src: _unref(img).cloud1,
        alt: "cloud",
        class: "cloud1 entered lazyloaded"
      }, null, 8, _hoisted_3),
      _createElementVNode("img", {
        width: "96",
        height: "56",
        src: _unref(img).cloud2,
        alt: "cloud",
        class: "cloud3 entered lazyloaded"
      }, null, 8, _hoisted_4),
      _createElementVNode("img", {
        width: "96",
        height: "56",
        src: _unref(img).cloud3,
        alt: "cloud",
        class: "cloud4 entered lazyloaded"
      }, null, 8, _hoisted_5),
      _createElementVNode("img", {
        width: "1920",
        height: "579",
        src: _unref(img).cloud5,
        alt: "cloud",
        class: "cloud6 entered lazyloaded"
      }, null, 8, _hoisted_6)
    ]),
    _hoisted_7
  ]))
}
}

})